import { ExtensionActivities } from './component'

export default ExtensionActivities
